import { Box, Button, Card, CardActions, CardContent, Chip, Divider, Stack, Typography, useTheme } from '@mui/material'
import moment from 'moment';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import TitleInfoStack from './TitleInfoStack';
import CancelSubscriptionDialog from './CancelSubscriptionDialog';

export default function PlanDetailsCard({
    subscriptionInfo,
    loading,
    hideActions = false
}) {
    const { t } = useTranslation();
    const theme = useTheme();

    const navigate = useNavigate();

    return (
        <Card>
            <CardContent>
                <Box display="flex" alignItems="center" gap={2}>
                    <Typography variant="h3">
                        {theme.direction === 'rtl' ? subscriptionInfo?.plan?.name_ar : subscriptionInfo?.plan?.name_en}
                    </Typography>
                    {!!subscriptionInfo?.status &&
                        <Chip
                            label={t(`subscriptionStatus.${subscriptionInfo?.status}`)}
                            color={subscriptionInfo?.status === 'ACTIVE' ? 'success' : 'error'}
                            variant="outlined"
                        />
                    }
                </Box>
                {(!subscriptionInfo?.autoRenew && !loading) &&
                    <Typography color="error" my={2}>
                        {t("cancelSubscriptionMessage")}
                    </Typography>
                }
                <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={5} mt={4}>
                    <TitleInfoStack
                        title={t('Start Date')}
                        value={moment(subscriptionInfo?.startDate).format('DD MMM, YYYY')}
                    />
                    <TitleInfoStack
                        title={t('Renewal Date')}
                        value={moment(subscriptionInfo?.endDate).format('DD MMM, YYYY')}
                    />
                    <TitleInfoStack
                        title={t('Next Billing Amount')}
                        elementValue={
                            <Box display="flex" alignItems="center" gap={1}>
                                <Typography fontWeight="bold">
                                    {subscriptionInfo?.subscriptionType === "MONTHLY" ? subscriptionInfo?.planId?.monthlyPrice : subscriptionInfo?.planId?.yearlyPrice}
                                </Typography>
                                <Typography fontWeight="bold" color="text.lighter">
                                    {` / ${subscriptionInfo?.subscriptionType === "MONTHLY" ? t('Monthly') : t('Yearly')}`}
                                </Typography>
                            </Box>
                        }
                    />
                </Box>
            </CardContent>
            {
                !hideActions &&
                <>
                    <Divider />
                    <CardActions>
                        <Box mr="auto" />
                        {subscriptionInfo?.autoRenew &&
                            <CancelSubscriptionDialog subscriptionInfo={subscriptionInfo} />
                        }
                        <Button variant="contained" sx={{ textTransform: "none" }} onClick={() => navigate("/merchant/account/plans")}>
                            {t("Upgrade Plan")}
                        </Button>
                    </CardActions>
                </>
            }
        </Card>
    )
}
